export default "__VITE_ASSET__VBVE6H3D__"